<template>
  <div
    v-if="paymentInfo.plan !== FREE_TARIFF_NAME"
    class="payment-info-extra-users"
  >
    <div class="payment-info-extra-users-title">
      <div class="payment-info-title-text">
        {{ $t('plans.additionalUsers') }}
      </div>
      <v-tooltip
        bottom
        max-width="300"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="grey"
            dark
            v-bind="attrs"
            icon
            x-small
            class="ml-2"
            v-on="on"
          >
            <v-icon :size="16">
              far fa-question-circle
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('plans.oneUserIncluded') }}</span>
      </v-tooltip>
    </div>

    <input
      v-if="!disabled"
      v-model="paymentInfo.additionalUsers"
      :placeholder="$t('plans.additionalUsers')"
      spellcheck="false"
      type="number"
      min="0"
      class="payment-info-input extra-users-input"
      @change="changeAdditionalUsers"
    />

    <input
      v-else
      v-model="paymentInfo.additionalUsers"
      :placeholder="$t('plans.additionalUsers')"
      spellcheck="false"
      type="number"
      min="0"
      :disabled="true"
      class="payment-info-input extra-users-input"
    />
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { FREE_TARIFF_NAME } from "@/constants/plans";

  export default {
    name: 'PaymentDialogExtraUsers',

    props: {
      disabled: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    data () {
      return {
        FREE_TARIFF_NAME
      }
    },

    computed: {
      ...mapGetters({
        paymentInfo: 'plans/paymentInfo',
        profile: 'main/profile'
      })
    },

    methods: {
      changeAdditionalUsers (e) {
        if (e.target.value === '' || e.target.value < 0) {
          this.paymentInfo.additionalUsers = 0
        }
      }
    }
  }
</script>

<style>
  .payment-info-extra-users-title {
    display: flex;
    align-items: center;
  }

  .payment-info-extra-users {
    margin-top: 24px;
  }

  .extra-users-input {
    margin-top: 6px;
    height: 40px;
  }

  .payment-info-input:disabled {
    background: rgba(200, 200, 200, 0.2);
    border: 1px solid rgba(147, 147, 147, 0.5);
    color: #A9ABB6;
  }
</style>